import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { STATUS_DOT_SIZE } from 'v2/constants';

export interface StatusLegendEntry {
  label: string;
  color: string;
  filled: boolean;
}

// Matches MUI SvgIcon fontSize="small"
const ICON_SIZE = 20;

export const StatusLegendItem: React.FC<StatusLegendEntry> = ({ label, color, filled }) => (
  <Stack direction="row" alignItems="center" spacing={1}>
    <Box display="flex" alignItems="center" justifyContent="center" sx={{ width: ICON_SIZE, height: ICON_SIZE }}>
      <Box
        sx={{
          width: STATUS_DOT_SIZE,
          height: STATUS_DOT_SIZE,
          borderRadius: '50%',
          backgroundColor: filled ? color : 'transparent',
          border: filled ? 'none' : `1px solid ${color}`
        }}
      />
    </Box>
    <Typography variant="caption">{label}</Typography>
  </Stack>
);
